import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'IS THIS A PHYSICAL OR DIGITAL PRODUCT?',
  answer: 'Cricket Ready: System 365 is a 100% digital product delivered instantly in PDF format. You can access it instantly from your PC, Mac, tablet, or smartphone, and it is fully printable.'
}, {
  question: 'DO I NEED ADVANCED COACHING EXPERIENCE TO USE IT?',
  answer: 'Not at all.\n\nThe system is engineered for coaches of all levels — including school, club, youth, and assistant coaches. The structured pathways take you step-by-step from U9 fundamentals up to U19 performance training.'
}, {
  question: 'CAN I PRINT THE MATERIALS?',
  answer: 'Yes!\n\nAll 6 volumes and 5 bonuses are fully formatted and optimized for printing so you can bring physical sheets right out to the pitch or nets.'
}, {
  question: 'ARE THE BONUSES REALLY INCLUDED FOR USD 27?',
  answer: 'Yes.\n\nIf you purchase during this limited launch window, all 5 premium bonuses (worth over USD 100 on their own) are included 100% free.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-navy-950 border-t border-navy-800" data-id="element-42">
      <div className="container mx-auto px-4" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-45">
            FREQUENTLY ASKED QUESTIONS
          </motion.h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-900 border border-navy-800 rounded-xl overflow-hidden" data-id="element-47">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500" data-id="element-48">
                <span className="font-oswald text-xl text-white uppercase tracking-wide pr-8" data-id="element-49">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-gold-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" />
              </button>

              <AnimatePresence data-id="element-51">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-52">
                    <div className="px-6 pb-6 text-gray-400 whitespace-pre-line" data-id="element-53">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}